import { CalendarViewType } from 'domains/models/event_type/calendarViewType';
import { DateTime } from 'infras/datetime';
import { useRouter } from 'next/router';
import { EventTypePathQuery } from 'presentations/routes/path';

export interface EventTypeUrlOptions {
  teamId?: string | null;
  eventTypeId?: string | null;
  guestSessionId?: string | null;
  formId?: string | null;
  formAnswerId?: string | null;
  sendUserId?: string | null;
  date?: string | null;
  time?: string | null;
  timeZone?: string | null;
  viewType?: CalendarViewType | null;
  utm: {
    medium?: string | null;
    campaign?: string | null;
    source?: string | null;
    content?: string | null;
    term?: string | null;
  };
}

export function useUrlAttributes() {
  const router = useRouter();

  const replaceUrlQuery = (
    query: EventTypeUrlOptions,
    replaceQuery: {
      selectedDate?: DateTime | null;
      selectedDatetime?: DateTime | null;
      timeZone?: string;
      viewType?: CalendarViewType;
    },
  ) => {
    const newQuery: EventTypePathQuery = {
      guestSessionId: query.guestSessionId,
      formId: query.formId,
      formAnswerId: query.formAnswerId,
      sendUserId: query.sendUserId,
      date: query.date,
      time: query.time,
      timeZone: query.timeZone,
      viewType: query.viewType,
      utm_campaign: query.utm.campaign,
      utm_content: query.utm.content,
      utm_term: query.utm.term,
      utm_medium: query.utm.medium,
      utm_source: query.utm.source,
    };

    if (replaceQuery.viewType) {
      newQuery.viewType = replaceQuery.viewType;
    } else if (replaceQuery.viewType === null) {
      newQuery.viewType = null;
    }

    if (replaceQuery.selectedDate !== undefined) {
      if (replaceQuery.selectedDate === null) {
        newQuery.date = null;
        newQuery.time = null;
      } else {
        newQuery.date = encodeURIComponent(
          replaceQuery.selectedDate.toFormat('yyyy-MM-dd'),
        );
        newQuery.time = null;
      }
    } else if (replaceQuery.selectedDatetime !== undefined) {
      // newQuery.date = encodeURIComponent(
      //   replaceQuery.selectedDatetime.toISO(),
      // );
      if (replaceQuery.selectedDatetime === null) {
        newQuery.date = null;
      } else {
        newQuery.date = encodeURIComponent(
          replaceQuery.selectedDatetime.toFormat('yyyy-MM-dd'),
        );
        newQuery.time = encodeURIComponent(
          replaceQuery.selectedDatetime.toFormat('HH:mm'),
        );
      }
    }

    if (replaceQuery.timeZone) {
      newQuery.timeZone = encodeURIComponent(replaceQuery.timeZone);
    } else if (replaceQuery.timeZone === null) {
      newQuery.timeZone = null;
    }

    // if (replaceQuery.selectedDate && replaceQuery.timeZone) {
    //   newQuery.date = encodeURIComponent(replaceQuery.selectedDate.toFormat('yyyy-MM-dd'));
    //   newQuery.time = undefined;
    //   newQuery.timeZone = encodeURIComponent(replaceQuery.timeZone);
    // } else if (replaceQuery.selectedDatetime) {
    //   newQuery.date = encodeURIComponent(replaceQuery.selectedDatetime.toISO());
    //   newQuery.time = encodeURIComponent(replaceQuery.selectedDatetime.toFormat('HH:mm'));
    //   newQuery.timeZone = encodeURIComponent(replaceQuery.timeZone);
    // } else if (replaceQuery.timeZone) {
    //   newQuery.timeZone = encodeURIComponent(replaceQuery.timeZone);
    // }
    return newQuery;
  };

  let teamId = null;
  if (router.query.teamId) {
    teamId = String(router.query.teamId);
  }

  let eventTypeId = null;
  if (router.query.eventTypeId) {
    eventTypeId = String(router.query.eventTypeId);
  }

  let guestSessionId = null;
  if (router.query.guestSessionId) {
    guestSessionId = String(router.query.guestSessionId);
  }

  let formId = null;
  if (router.query.formId) {
    formId = String(router.query.formId);
  }

  let formAnswerId = null;
  if (router.query.formAnswerId) {
    formAnswerId = String(router.query.formAnswerId);
  }

  let sendUserId = null;
  if (router.query.sendUserId) {
    sendUserId = String(router.query.sendUserId);
  }

  let date = null;
  if (router.query.date) {
    date = String(router.query.date);
  }

  let time = null;
  if (router.query.time) {
    time = String(router.query.time);
  }

  let timeZone = null;
  if (router.query.tz) {
    timeZone = String(router.query.tz);
  }

  let viewType = null;
  if (router.query.viewType) {
    viewType = Number(router.query.viewType);
  }

  let medium = null;
  if (router.query.utm_medium) {
    medium = String(router.query.utm_medium);
  }

  let campaign = null;
  if (router.query.utm_campaign) {
    campaign = String(router.query.utm_campaign);
  }

  let content = null;
  if (router.query.utm_content) {
    content = String(router.query.utm_content);
  }

  let source = null;
  if (router.query.utm_source) {
    source = String(router.query.utm_source);
  }

  let term = null;
  if (router.query.utm_term) {
    term = String(router.query.utm_term);
  }
  return {
    state: {
      teamId,
      eventTypeId,
      guestSessionId,
      formId,
      formAnswerId,
      sendUserId,
      date,
      time,
      viewType,
      timeZone,
      utm: {
        medium,
        campaign,
        content,
        source,
        term,
      },
    },
    actions: {
      replaceUrlQuery,
    },
  };
}
